<template>
  <div id="commentCard">
    <div class="row text-left">
      <div class="col-2 col-sm-1 text-left pointer" style="font-size:20px;">
        <i class="fal fa-bars mb-3 move-item"></i>
        <br />
        <i class="fal fa-edit mb-3 edit-item" @click="editThisItem"></i>
        <br />
        <i class="fal fa-trash-alt trash-item" @click="alertDelete = true"></i>
      </div>

      <div class="col-10 col-lg pl-2">
        <div class="row align-items-center">
          <div class="card-alert text-center" v-if="alertDelete">
            <div>
              <p>
                Deseja realmente excluir este item?
              </p>
              <p>
                <button
                  class="confirm-button"
                  @click.prevent="removeComment"
                >
                  Excluir
                </button>
                <button
                  class="cancel-button"
                  @click.stop.prevent="alertDelete = false"
                >
                  Cancelar
                </button>
              </p>
            </div>
          </div>
          <div
            class="col-12 col-md-auto total-avatar"
            @click="handleUploadAvatar()"
          >
            <div class="d-flex align-self-start">
              <img v-if="comment.frameContent.picture"
                class="avatar-comment rounded-circle"
                :src="
                  'https://s3-sa-east-1.amazonaws.com/uli-upload/' +
                    comment.frameContent.picture
                "
                alt
              />
              <img v-else
                class="avatar-comment rounded-circle"
                src="/static/img/default-user.png"
                alt
              />
            </div>
          </div>
          <div class="col">
            <div class="username d-block">
              <h5 class="font-20">
                {{ comment.frameContent.name }}
              </h5>
            </div>
          </div>
          <div class="col-12 pt-4">
            <p v-html="comment.frameContent.text"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "commentCard",
  data() {
    return {
      CDN_URL: null,
      ROOT_API: null,
      file: "",
      commentCard: null,
      alertDelete:false
    };
  },
  props: {
    comment: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean
    }
  },
  methods: {
    handleUploadAvatar,
    handleFileUpload,
    concatenateAvatar,
    removeComment,
    editThisItem
  },
  created() {
    this.CDN_URL = process.env.CDN_URL;
    this.ROOT_API = process.env.ROOT_API;
    // this.comment = this.commentCard
  }
};
function editThisItem() {
  this.$emit("editThisItem");
}
function removeComment() {
  this.$emit("removeComment");
}
function handleUploadAvatar() {
  document.getElementById("inputAvatar" + this.comment.frameId).click();
}
function handleFileUpload() {
  this.file = this.$refs.file.files[0];
  let str = this.file.name.toLowerCase().split(".");
  if (
    str[str.length - 1] == "jpeg" ||
    str[str.length - 1] == "jpg" ||
    str[str.length - 1] == "png"
  ) {
    let siteId = this.$session.get("siteId");
    let token = this.$session.get("jwt");
    let formData = new FormData();
    formData.append("siteId", siteId);
    formData.append("images[]", this.file);
    axios({
      method: "post",
      url: this.ROOT_API + "api/site/" + siteId + "/image/upload",
      data: formData,
      headers: {
        Authorization: "Bearer " + token
      }
    })
      .then(response => {
        if (response.data.status == 1) {
          this.comment.frameContent.picture = response.data.url;
        }
      })
      .catch(response => {
        console.log("Erro ao enviar imagem");
        console.log(response);
      });
  } else {
    alert("Formato incompatível");
  }
}
function concatenateAvatar(picture) {
  let totalAvatar = "https://via.placeholder.com/70";
  if (picture) {
    totalAvatar = "https://s3-sa-east-1.amazonaws.com/uli-upload/" + picture;
  }
  return totalAvatar;
}
</script>

<style scoped>
.card-alert {
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #f8f8fae6;
		color: #333;
		padding: 20px;
		z-index: 2;
		font-weight: 700;
		font-size: 16px;
    position: absolute;
    width: 100%;
    height: 100%;
	}

.card-alert button {
  border-radius: 50px;
  margin: 10px 8px;
  padding: 8px;
  min-width: 104px;
  background: none;
  border: none;
  color: #f2f2f2;
}
.card-alert button.confirm-button {
  background-color: #777777;
}
.card-alert button.cancel-button {
  background-color: var(--main-color);
}
.total-avatar:hover {
  cursor: pointer;
}
.avatar-comment {
  width: 60px;
  height: 60px;
  display: inline-block;
  object-fit: cover;
}
hr {
  margin-top: 22px;
  margin-bottom: 22px;
}
.edit-item,
.move-item,
.trash-item {
  opacity: 0.5;
  cursor: pointer;
  transition: opacity 0.2s ease;
}
.edit-item:hover,
.move-item:hover,
.trash-item:hover {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/blocks/CommentCard.vue